import TrellisLink from "components/core/basic/TrellisLink";
import useDSPSellerInfo from "./hooks/useDSPSellerInfo";
import { Redirect } from "react-router";
import { useAppSelector } from "redux/hooks";
import { PageContainer } from "components/core/basic/PageContainer";
import Loading from "components/core/blocks/Loading";

const DSPAdvertisers = () => {
  const { dspAdvertisers, isLoading } = useDSPSellerInfo();
  const { marketPlace } = useAppSelector((state) => state.marketPlace);

  if (isLoading) {
    return <Loading />;
  }

  if (dspAdvertisers?.length === 1) {
    return <Redirect to={`/user/dsp/${dspAdvertisers[0].id}/dashboard`} />;
  }
  if (
    dspAdvertisers?.filter((d) => d.marketplace === marketPlace || (marketPlace === "USA" && d.marketplace === "US"))
      .length === 1
  ) {
    const advertiser = dspAdvertisers.find(
      (d) => d.marketplace === marketPlace || (marketPlace === "USA" && d.marketplace === "US"),
    );
    return <Redirect to={`/user/dsp/${advertiser.id}/dashboard`} />;
  }
  return (
    <PageContainer>
      <h3>DSP Profiles</h3>
      {dspAdvertisers?.map((profile) => (
        <div key={profile.id}>
          <TrellisLink to={`/user/dsp/${profile.id}/dashboard`}>
            {profile.id} ({profile.marketplace})
          </TrellisLink>
        </div>
      ))}
    </PageContainer>
  );
};

export default DSPAdvertisers;
